import React, {FC} from "react";
import {Autocomplete} from "@material-ui/lab";
import {TextField, TextFieldProps} from "@material-ui/core";
import {GridFilterInputValueProps} from "@material-ui/data-grid";
import {FeWorker, Worker} from "../redux/types";
import {getFullName} from "../../../utils";
import {useField} from "formik";
import {useWorkers} from "../redux/workers.hook";

interface WorkerAutoCompleteProps {
    selectedId: string | null;
    onChange: (worker: FeWorker | null) => void;
    textFieldProps?: TextFieldProps;
}

export const WorkerAutoComplete: FC<WorkerAutoCompleteProps> = ({onChange, textFieldProps, selectedId}) => {
    const {workers} = useWorkers();
    console.log("sel", selectedId);
    const selectedWorker = selectedId ? workers.find(c => c.id === selectedId) : undefined;
    return (
        <Autocomplete
            fullWidth
            options={workers}
            value={selectedWorker || null}
            getOptionLabel={(worker) => getFullName(worker)}
            onChange={(_event, selectedWorker) =>
                onChange(selectedWorker)
            }
            renderInput={(params) => <TextField {...textFieldProps} {...params} label="Gartenarbeiter"/>}
        />
    )
}

type FormikWorkerAutoCompleteProps = Omit<TextFieldProps, 'name'> & { name: string };

export const FormikWorkerAutoComplete: FC<FormikWorkerAutoCompleteProps> = (props) => {
    const {name, ...restProps} = props;
    const [, meta, helpers] = useField<string | undefined>(name);

    return (
        <WorkerAutoComplete
            selectedId={meta.value || null}
            onChange={(worker) => {
                if (worker) {
                    helpers.setValue(worker.id)
                }
            }}
            textFieldProps={{
                ...restProps,
                error: meta.touched && Boolean(meta.error),
                helperText: meta.touched && meta.error
            }}
        />
    )
}

export function WorkerGridFilterInput(props: GridFilterInputValueProps) {
    const {item, applyValue} = props;

    const onChangeWorker = (worker: Worker | null) => {
        if (worker) {
            applyValue({
                ...item,
                value: worker.id
            });
        }
    };

    return (<WorkerAutoComplete selectedId={item.value} onChange={onChangeWorker}/>);
}
